import {
  REPOSITORY_EMAIL,
  REPOSITORY_VEYO,
  REPOSITORY_VOICE,
} from "core/consts";

export type Locales = { [key: string]: string };

export type LocalesType = {
  de: string;
  en: string;
};

export type TranslationSimpleType = {
  [key: string]: TranslationSimpleType | string;
};

export type TranslationType = {
  created_at?: number;
  description: string | null;
  id: string;
  links: Array<{ description: string; link: string }> | null;
  locales: LocalesType;
  tags: Array<number> | null;
  updated_at?: number;
};

export type TranslationTypes = Array<TranslationType>;

export type Selection = [string, TranslationType];

export type FormValue = Array<number> | boolean | number | string;

export type FormValueComposition = {
  validate?: (value: FormValue, formState: ComputedFormModel) => string | null;
  value: FormValue;
};

export type FormValueModel = FormValue | FormValueComposition;

export type FormModel = {
  [key: string]: FormValueModel;
};

export type FormUtilities = {
  error: string | null;
};

export type ComputedFormModel = {
  [key: string]: FormUtilities & FormValueComposition;
};

export enum SearchType {
  Content = "text",
  Context = "context",
}

export type Search = {
  tags: number[];
  text: string;
  type: SearchType;
};

export type Requirement = { dictionary?: string[]; name: string };

export type Suggestion = SuggestionNoTrigger & {
  trigger: string;
};

export type SuggestionNoTrigger = {
  complete: (args: Array<string>) => string;
  description: string;
  name: string;
  requirements: Requirement[];
};

export type EmailTranslation = {
  created_at?: number;
  id: string;
  translation: string;
  updated_at?: number;
};

export type EmailTranslations = Array<EmailTranslation>;
export type EmailSelection = [string, EmailTranslation];
export type RepositoryType = typeof REPOSITORY_VEYO | typeof REPOSITORY_VOICE;
export type EmailRepositoryType = typeof REPOSITORY_EMAIL;

export type TranslationsAndRepo =
  | {
      emailTranslations?: never;
      repo: RepositoryType;
      translations: Readonly<Array<TranslationType>>;
    }
  | {
      emailTranslations: Readonly<Array<EmailTranslation>>;
      repo: EmailRepositoryType;
      translations?: never;
    };
